var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTurborepo = function SvgTurborepo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "318px",
    viewBox: "0 0 256 318",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "turborepo")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "123.779228%",
    y1: "-3.85716965e-07%",
    x2: "123.779228%",
    y2: "698.962346%",
    id: "turborepo_svg__turborepo-linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E56",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.4859916%",
    y1: "-2.19377472%",
    x2: "11.4859916%",
    y2: "512.39779%",
    id: "turborepo_svg__turborepo-linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E56",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-153.743225%",
    y1: "-62.2632095%",
    x2: "-153.743225%",
    y2: "278.479413%",
    id: "turborepo_svg__turborepo-linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E56",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-153.743225%",
    y1: "-178.48023%",
    x2: "-153.743225%",
    y2: "162.263952%",
    id: "turborepo_svg__turborepo-linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E56",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.4859916%",
    y1: "-412.397334%",
    x2: "11.4859916%",
    y2: "102.193662%",
    id: "turborepo_svg__turborepo-linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E56",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "123.779228%",
    y1: "-598.960854%",
    x2: "123.779228%",
    y2: "99.9997513%",
    id: "turborepo_svg__turborepo-linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1E56",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.409919,0.0945810675 C66.8366598,-1.16649961 30.2676723,10.1832239 0,34.1437712 L20.1770242,45.4933581 C44.1391095,27.838355 74.4025099,20.2718642 103.409919,21.5329389 L103.409919,0.0945810675 Z",
    fill: "url(#turborepo_svg__turborepo-linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.600627,48.0155928 C185.378279,21.5328962 152.590081,5.13883968 117.281356,1.35559852 L117.281356,22.7939708 C147.549029,27.8383123 174.03164,41.7101766 195.468927,63.1485746 L210.600627,48.0155928 Z",
    fill: "url(#turborepo_svg__turborepo-linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,151.42423 C254.739737,118.636032 242.128563,85.8478338 220.691275,58.1041051 L205.555303,73.2370868 C223.211802,97.1978904 233.30245,123.680502 234.562713,151.42423 L256,151.42423 Z",
    fill: "url(#turborepo_svg__turborepo-linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.691275,259.876911 C242.128563,232.133182 254.739737,199.345411 256,166.557212 L234.562713,166.557212 C233.30245,194.300941 223.211802,220.783552 205.555303,244.743929 L220.691275,259.876911 Z",
    fill: "url(#turborepo_svg__turborepo-linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.281356,316.625913 C151.329818,312.84256 185.378279,296.44846 210.600627,269.96585 L195.468927,254.832868 C174.03164,277.532127 146.284494,291.403993 117.281356,295.187343 L117.281356,316.625913 Z",
    fill: "url(#turborepo_svg__turborepo-linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,283.837714 C30.2676723,307.79809 66.8366598,319.147719 103.409919,317.88703 L103.409919,296.44846 C74.4025099,297.70958 45.3993724,290.142873 20.1770242,272.488085 L0,283.837714 Z",
    fill: "url(#turborepo_svg__turborepo-linearGradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.6511578,71.3437019 C111.129564,71.3437019 123.569854,73.6390892 134.972031,78.2302915 C146.374206,82.6732526 156.148722,88.893398 164.295573,96.8907279 C172.587676,104.888058 179.02997,114.292183 183.622455,125.103531 C188.214939,135.766638 190.509044,147.318336 190.509044,159.758627 C190.509044,172.198918 188.214939,183.824524 183.622455,194.635872 C179.02997,205.298979 172.587676,214.629197 164.295573,222.626527 C156.148722,230.623857 146.374206,236.917909 134.972031,241.509111 C123.569854,245.952072 111.129564,248.173553 97.6511578,248.173553 C84.0274998,248.173553 71.5103114,245.952072 60.1081367,241.509111 C48.8512106,236.917909 39.1535939,230.623857 31.0067421,222.626527 C22.8598876,214.629197 16.4944931,205.298979 11.9020085,194.635872 C7.30952399,183.824524 5.0154192,172.198918 5.0154192,159.758627 C5.0154192,147.318336 7.30952399,135.766638 11.9020085,125.103531 C16.4944931,114.292183 22.8598876,104.888058 31.0067421,96.8907279 C39.1535939,88.893398 48.8512106,82.6732526 60.1081367,78.2302915 C71.5103114,73.6390892 84.0274998,71.3437019 97.6511578,71.3437019 Z M97.6511578,113.551832 C91.2814883,113.551832 85.2108658,114.736479 79.4350181,117.106201 C73.8086911,119.327681 68.8445353,122.511661 64.5510977,126.658567 C60.2576602,130.805473 56.8485416,135.692731 54.3322862,141.320339 C51.8160337,146.947947 50.5557685,153.094186 50.5557685,159.758627 C50.5557685,166.423069 51.8160337,172.569308 54.3322862,178.196916 C56.8485416,183.824524 60.2576602,188.711781 64.5510977,192.858687 C68.8445353,197.005594 73.8086911,200.26348 79.4350181,202.633202 C85.2108658,204.854682 91.2814883,205.965423 97.6511578,205.965423 C104.020825,205.965423 110.018823,204.854682 115.64515,202.633202 C121.421,200.26348 126.45778,197.005594 130.751218,192.858687 C135.194179,188.711781 138.675922,183.824524 141.192177,178.196916 C143.70843,172.569308 144.968692,166.423069 144.968692,159.758627 C144.968692,153.094186 143.70843,146.947947 141.192177,141.320339 C138.675922,135.692731 135.194179,130.805473 130.751218,126.658567 C126.45778,122.511661 121.421,119.327681 115.64515,117.106201 C110.018823,114.736479 104.020825,113.551832 97.6511578,113.551832 Z",
    fill: "#000000"
  }))));
};
export default SvgTurborepo;